export const AppFeatures = {
    PROFILE: 'profile',
    ONBOARDING: 'onboarding',
    ADD_SECONDARY_EMAIL: 'addsecondaryemail',
    CHAT: 'chat',
    REGISTRATION: 'registration',
    SIMPLE_REGISTRATION: 'simpleregistration',
};
